module.exports = __webpack_public_path__ + "static/media/Azurill_gaussian2.83fa6453.png";